import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { GetEpubsResponse } from "@ilteducation/epub-guide-generator-types";
import EditEpubGuideform from "@/components/epubguide/EditEpubGuideform.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditMultipleEpubGuideDialog',
  props: {
    selectedEpubs: null
  },
  setup(__props: any) {



const dialog = ref<boolean>(false);

const closeMenu = () => {
  dialog.value = false;
};

return { __sfc: true,dialog, closeMenu, EditEpubGuideform }
}

})